import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=2173b7e4"
import script from "./DocumentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentsView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports